 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TITLEPAGE from '@/components/title-page'
 import EBOOKCOPYRIGHT from '@/components/ebook-copyright'
 import CONTENTS from '@/components/contents'
 import EPIGRAPH from '@/components/epigraph'
 import FOREWORD from '@/components/foreword'
 import FULLPAGEIMAGE from '@/components/full-page-image'
 import INTRODUCTION from '@/components/introduction'
 import FULLPAGEIMAGE2 from '@/components/full-page-image-2'
 import CHAPTER001 from '@/components/chapter-001'
 import FULLPAGEIMAGE3 from '@/components/full-page-image-3'
 import CHAPTER002 from '@/components/chapter-002'
 import FULLPAGEIMAGE4 from '@/components/full-page-image-4'
 import CHAPTER003 from '@/components/chapter-003'
 import FULLPAGEIMAGE5 from '@/components/full-page-image-5'
 import CHAPTER004 from '@/components/chapter-004'
 import FULLPAGEIMAGE6 from '@/components/full-page-image-6'
 import CHAPTER005 from '@/components/chapter-005'
 import FULLPAGEIMAGE7 from '@/components/full-page-image-7'
 import CHAPTER006 from '@/components/chapter-006'
 import FULLPAGEIMAGE8 from '@/components/full-page-image-8'
 import CHAPTER007 from '@/components/chapter-007'
 import FULLPAGEIMAGE9 from '@/components/full-page-image-9'
 import CHAPTER008 from '@/components/chapter-008'
 import FULLPAGEIMAGE10 from '@/components/full-page-image-10'
 import CHAPTER009 from '@/components/chapter-009'
 import FULLPAGEIMAGE11 from '@/components/full-page-image-11'
 import CHAPTER010 from '@/components/chapter-010'
 import FULLPAGEIMAGE12 from '@/components/full-page-image-12'
 import CHAPTER011 from '@/components/chapter-011'
 import FULLPAGEIMAGE13 from '@/components/full-page-image-13'
 import CHAPTER012 from '@/components/chapter-012'
 import FULLPAGEIMAGE14 from '@/components/full-page-image-14'
 import CHAPTER013 from '@/components/chapter-013'
 import FULLPAGEIMAGE15 from '@/components/full-page-image-15'
 import CHAPTER014 from '@/components/chapter-014'
 import SALVATIONPRAYER from '@/components/salvation-prayer'
 import BEFOREYOUGO from '@/components/before-you-go'
 import ACKNOWLEDGMENTS from '@/components/acknowledgments'
 import FULLPAGEIMAGE16 from '@/components/full-page-image-16'
 import ABOUTTHEAUTHOR from '@/components/about-the-author'
 import WORKSCITED from '@/components/works-cited'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/epigraph",
 			"name" : "epigraph",
 			"component" : EPIGRAPH
 		},
 		{
 			"path" : "/foreword",
 			"name" : "foreword",
 			"component" : FOREWORD
 		},
 		{
 			"path" : "/full-page-image",
 			"name" : "full-page-image",
 			"component" : FULLPAGEIMAGE
 		},
 		{
 			"path" : "/introduction",
 			"name" : "introduction",
 			"component" : INTRODUCTION
 		},
 		{
 			"path" : "/full-page-image-2",
 			"name" : "full-page-image-2",
 			"component" : FULLPAGEIMAGE2
 		},
 		{
 			"path" : "/chapter-001",
 			"name" : "chapter-001",
 			"component" : CHAPTER001
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js